// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-white: #fff;
    --primary-black: #000;
    --primary-grey: #73739a;
    --primary-grey2: #fffc;
    --primary-blue: #6d72f6;
    --primary-green: #08ce8a;
    --primary-black2: #1c1c57;
  }

  .BulkSMS{
    overflow-x: hidden;
    width: 100%;
  }

.BulkSMS-container {
    font-family: Arial, sans-serif;
    margin: 20px;
    padding: 20px;
    /* background-color: #f9f9f9; */
    border-radius: 8px;
}

.BulkSMS-container h1 {
    color: var(--primary-blue);
    font-size: 30px;
    text-align: center;
}

.BulkSMS-container hr {
    border: 0;
    height: 1px;
    background: #ddd;
    margin: 10px 0;
}

.BulkSMS-container p {
    line-height: 2rem;
    color: var(--primary-grey);
    margin: 10px 0;
}

.BulkSMS-content-box {
    margin-top: 20px;
    background-color: #fff;
    /* border: 1px solid #ccc; */
    border-radius: 8px;
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
}

.button-group {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
}

button.whatsapp {
    background-color: #25D366;
}

button.telegram {
    background-color: #0088CC;
}

button.skype {
    background-color: #00AFF0;
}



.bulk-container{
    display: flex;
    align-items: center;
    width: 100%;
    /* gap: 50px; */
    padding: 0 40px;
  }
.bulk-container h2{
    color: var(--primary-blue);
    font-size: 30px;
    font-family: Arial, Helvetica, sans-serif;
    /* text-align: center; */
}
  .bulk-container ul li{
    line-height: 40px;
    color: var(--primary-grey);
    margin: 10px 0;
    font-family: Arial, Helvetica, sans-serif;
  }
  .bulk-box-img{
    display: flex;
    justify-content: center;
    width: 50%;
  }

  @media (max-width: 1024px){
    .bulk-container{
        flex-direction: column;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Components/VAS_Service/BulkSMS/BulkSMS.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;AAEF;IACI,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;EACjB;AACF;IACI,0BAA0B;IAC1B,eAAe;IACf,yCAAyC;IACzC,wBAAwB;AAC5B;EACE;IACE,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE;QACI,sBAAsB;IAC1B;EACF","sourcesContent":[":root {\n    --primary-white: #fff;\n    --primary-black: #000;\n    --primary-grey: #73739a;\n    --primary-grey2: #fffc;\n    --primary-blue: #6d72f6;\n    --primary-green: #08ce8a;\n    --primary-black2: #1c1c57;\n  }\n\n  .BulkSMS{\n    overflow-x: hidden;\n    width: 100%;\n  }\n\n.BulkSMS-container {\n    font-family: Arial, sans-serif;\n    margin: 20px;\n    padding: 20px;\n    /* background-color: #f9f9f9; */\n    border-radius: 8px;\n}\n\n.BulkSMS-container h1 {\n    color: var(--primary-blue);\n    font-size: 30px;\n    text-align: center;\n}\n\n.BulkSMS-container hr {\n    border: 0;\n    height: 1px;\n    background: #ddd;\n    margin: 10px 0;\n}\n\n.BulkSMS-container p {\n    line-height: 2rem;\n    color: var(--primary-grey);\n    margin: 10px 0;\n}\n\n.BulkSMS-content-box {\n    margin-top: 20px;\n    background-color: #fff;\n    /* border: 1px solid #ccc; */\n    border-radius: 8px;\n    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\n}\n\n.button-group {\n    display: flex;\n    gap: 10px;\n    margin-top: 20px;\n}\n\nbutton {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #fff;\n}\n\nbutton.whatsapp {\n    background-color: #25D366;\n}\n\nbutton.telegram {\n    background-color: #0088CC;\n}\n\nbutton.skype {\n    background-color: #00AFF0;\n}\n\n\n\n.bulk-container{\n    display: flex;\n    align-items: center;\n    width: 100%;\n    /* gap: 50px; */\n    padding: 0 40px;\n  }\n.bulk-container h2{\n    color: var(--primary-blue);\n    font-size: 30px;\n    font-family: Arial, Helvetica, sans-serif;\n    /* text-align: center; */\n}\n  .bulk-container ul li{\n    line-height: 40px;\n    color: var(--primary-grey);\n    margin: 10px 0;\n    font-family: Arial, Helvetica, sans-serif;\n  }\n  .bulk-box-img{\n    display: flex;\n    justify-content: center;\n    width: 50%;\n  }\n\n  @media (max-width: 1024px){\n    .bulk-container{\n        flex-direction: column;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
